import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { VoucherPurchaseService } from './shared/services/voucher-purchase.service';
import { VoucherPurchaseComponent } from './purchase/voucher-purchase.component';
import { NgxCaptchaModule } from "ngx-captcha";
import { NgxMaskModule } from 'ngx-mask';



@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    NgxCaptchaModule
  ],
  declarations: [
    VoucherPurchaseComponent
  ],
  providers: [VoucherPurchaseService]
})
export class VoucherPurchaseModule { }
